import request from './request';

const point_of_interests = {
	async getPointOfInterests(query) {
		const response = await request.get('/app/point-of-interests', query);
		return response;
	}
};

export default point_of_interests;